/* eslint-disable no-nested-ternary */
import React, { useEffect, useLayoutEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, theme, Modal } from 'fpay-ui';

import { Filters, Table, Pagination, List } from '@components/Reports';
import { CreateReportsForRangeTime, ReportsMenu, CreateReportsProgram } from '@components';
import useReports from 'hooks/useReports';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { useSelector } from 'react-redux';

import { isAllowed } from 'helpers/auth';

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Description = styled.div`
  font-size: 16px;
  padding-bottom: 16px;
`;

export const Reports = () => {
  const { t } = useTranslation();
  const { fetchReports, createReport, newReportModal, scheduledReport, showSkeletonReport } =
    useReports();
  const [openCreateReport, setOpenCreateReport] = useState(false);
  const { breakpoint } = useBreakpoints();
  const [page, setPage] = useState('menu');
  const { isSkeleton } = useSelector((state) => state.reports) || true;
  const [program, setProgram] = useState(null);

  const [value, setValue] = useState(null);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const selectReport = () => {
    setPage(value);
  };

  const handleChangeProgram = (event) => {
    setProgram(event.target.value);
  };

  const closePages = () => {
    setOpenCreateReport(false);
    setPage('menu');
    setValue(null);
    setProgram(null);
  };

  useLayoutEffect(() => {
    showSkeletonReport();
  }, []);

  useEffect(() => {
    fetchReports();
    // eslint-disable-next-line
  }, []);

  useEffect(() => newReportModal === 'end' && closePages(), [newReportModal]);

  const CreateReportButton = styled(Button)`
    width: 100%;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-top: 12px;
    padding-bottom: 12px;
    ${theme.breakpoint('md')} {
      width: 129px;
    }
  `;

  // TODO INTEGRATE PROGRAM
  // const createReportProgram = () => {
  //   closePages();
  //   if (successReport)
  //     return dispatch(
  //       showError(
  //         successResponsive('Tu reporte se programo con éxito. Accede a tus reportes desde el menú')
  //       )
  //     );
  // };

  const ContainerButton = styled.div`
    margin-bottom: 16px;
    display: flex;
    width: 100%;
    justify-content: flex-end;
  `;

  return (
    <>
      <Content>
        {isAllowed('REPORT_FILTERS') ? (
          <Filters handleClickCreateReport={() => setOpenCreateReport(true)} />
        ) : (
          <ContainerButton>
            <CreateReportButton id="create-report" onClick={() => setOpenCreateReport(true)}>
              {t('reportsScreen.createTitle')}
            </CreateReportButton>
          </ContainerButton>
        )}
        <Table skeleton={isSkeleton} />
        <List skeleton={isSkeleton} />
        <Pagination />
      </Content>
      {openCreateReport && (
        <Modal
          fClose={closePages}
          showCloseButton={false}
          width={breakpoint === 'xs' ? '312px' : '400px'}
          height={page === 'menu' ? '290px' : page === 'SCHEDULED' ? '430px' : '350px'}
          overflowY="inherit"
        >
          {page === 'menu' && (
            <ReportsMenu
              handleChange={handleChange}
              value={value}
              handleClose={() => setOpenCreateReport(false)}
              handleClick={selectReport}
            />
          )}
          {page === 'DATA_RANGE' && (
            <CreateReportsForRangeTime handleClose={closePages} handleCreate={createReport} />
          )}
          {page === 'CUSTOM' && (
            <>
              <div>soy un Reporte</div>
              <div onClick={closePages}>cerrar</div>
            </>
          )}
          {page === 'SCHEDULED' && (
            <>
              <CreateReportsProgram
                handleClose={closePages}
                handleChange={handleChangeProgram}
                value={program}
                filterProgram={!program}
                handleCreate={scheduledReport}
              />
            </>
          )}
        </Modal>
      )}
    </>
  );
};

export default Reports;
